export default class Legend {
  _targets = [];
  _hidden = false;
  _resizeListening = false;

  constructor({ draw, remove }) {
    this._draw = draw;
    this._remove = remove;
  }

  draw = container => {
    let target = this._targets.find(t => t.container === container);
    if (!target) {
      target = { container: container };
      this._targets.push(target);
    }
    this._draw(target);
    if (!this._resizeListening) {
      window.addEventListener("resize", this.resize_listener);
      this._resizeListening = true;
    }
  };

  remove = container => {
    const target = this._targets.find(t => t.container === container);
    if (target) {
      this._remove(target);
      this._targets = this._targets.filter(t => t.container !== container);
    }
    if (this._targets.length === 0) {
      window.removeEventListener("resize", this.resize_listener);
      this._resizeListening = false;
    }
  };

  showAll = () => {
    this._hidden = false;
    this._targets.forEach(t => this._draw(t));
    if (this._targets.length > 0 && !this._resizeListening) {
      window.addEventListener("resize", this.resize_listener);
      this._resizeListening = true;
    }
  };

  hideAll = () => {
    this._targets.forEach(t => this._remove(t));
    this._hidden = true;
    window.removeEventListener("resize", this.resize_listener);
    this._resizeListening = false;
  };

  get targets() {
    return this._targets;
  }

  resize_listener = e => {
    this._targets.forEach(t => {
      this._remove(t);
      this._draw(t);
    });
  };
}
